export class FeedbackEndpoints {
  // Feedback Endpoints
  feedback() {
    return '/hydra/v1/feedback';
  }

  showFeedback() {
    return "/hydra/v1/feedback/show-popup";
  }
}